import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export const AddtoFavouritesAsync = async (
    addressId: number,
    token: string
  ): Promise<any> => {
    const baseUrl = getApiBaseUrl();
    const apiUrl = `${baseUrl}/api/AddressFavourites/AddToFavouritesAsync`;
    const payload = { addressId, isFavourite: true };
  
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
        throw new Error(`Failed to add to favourites: ${response.statusText}`);
      }
  
      return response.json();
    } catch (error) {
      // console.error('Error in AddtoFavouritesAsync:', error);
      throw error;
    }
  };
  